module.exports = __webpack_public_path__ + "img/info02.0b57ef84.png";